const serviceItem = [
    {
        heading : "다양한 제품",
        description : `기내용, 화물용 캐리어부터 미니캐리어까지!
        용도와 기간에 맞는 캐리어를 만나보세요!`,
        iconClass: "fas fa-suitcase-rolling fa-stack-1x fa-inverse"
    },
    {
        heading : "착한 가격",
        description : `캐리빌리는 기간당 가격으로 저렴하게 제공합니다!`,
        iconClass: "fas fa-won-sign fa-stack-1x fa-inverse"
    },
    {
        heading : "공간 활용",
        description : `자리만 차지하는 커다란 캐리어.
        필요할 때만 빌리고 캐리어의 빈 자리는 원하는 공간으로 활용하세요!`,
        iconClass: "fas fa-arrows-alt-h fa-stack-1x fa-inverse"
    },
]

function Services(){
    return (
        <section className="page-section" id="services">
            <div className="container">
                <div className="text-center">
                <h2 className="section-heading text-uppercase">Services</h2>
                <h3 className="section-subheading text-muted">
                    자주 안 쓰는데 사놓으면 자리만 차지하는 여행 캐리어<br />
                    캐리빌리에서 저렴하게 빌려서 사용하세요!
                </h3>
                </div>
                <div className="row text-center">
                    {serviceItem.map((item) => 
                        <div className="col-md-4" key={item.heading}>
                            <span className="fa-stack fa-4x">
                                <i className="fas fa-circle fa-stack-2x text-primary"></i>
                                <i className={item.iconClass}></i>
                            </span>
                            <h4 className="my-3">{item.heading}</h4>
                            <p className="text-muted">
                                {item.description}
                            </p>
                        </div>
                    )}                    
                </div>
            </div>
        </section>
    );
}

export default Services;